export const BACK_TO_TOP_SCROLL_DURATION = 750
export default BACK_TO_TOP_SCROLL_DURATION
